import React, { useState, useContext } from "react";
import { NotificationManager } from "react-notifications";
import useApi from "../Api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SideLabelInput from "../Components/SideLabelInput";
import Button from "../Components/Button";
import AddProduct from "./AddProduct";
import UploadProduct from "../Forms/UploadProduct";
import { FilterContext } from "../FilterContextProvider";

const AddArtist = ({ handleShowArtistDrawer, getArtists }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [showSelf, setShowSelf] = useState(true);
  const [showManualForm, setShowManualForm] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const { filterData, setFilterData } = useContext(FilterContext);
  const api = useApi();
  const fromArtistPage = true;
  const [artist, setArtist] = useState({
    name: "",
    notes: "",
    payment_info: "",
    active: false,
    street_address: "",
    city: "",
    state: "",
    zip_code: "",
    business_name: "",
    tax_id: "",
    tempManagerPercentage: "",
  });

  let today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();

  today = yyyy + "-" + mm + "-" + dd;

  const [artistSplit, setArtistSplit] = useState({
    effective_date: today,
    tempSplitPercentage: "",
  });

  const [isManual, setIsManual] = useState(true);
  const handleIsManual = () => {
    setIsManual(true);
    setIsUpload(false);
  };

  const [isUpload, setIsUpload] = useState(false);
  const handleIsUpload = () => {
    setIsUpload(true);
    setIsManual(false);
  };

  const handleShowSelf = () => {
    setShowSelf(!showSelf);
    setShowManualForm(false);
    setShowUploadForm(false);
  };

  const handleShowManualForm = () => {
    setShowManualForm(!showManualForm);
    setShowUploadForm(false);
    setShowSelf(false);
  };

  const handleShowUploadForm = () => {
    setShowUploadForm(!showUploadForm);
    setShowManualForm(false);
    setShowSelf(false);
  };

  const handleSubmit = (event) => {
    setIsFetching(true);
    api
      .post("/artists", {
        artist: {
          ...artist,
          manager_commission_percentage: artist.tempManagerPercentage / 100,
          artist_splits_attributes: [
            {
              ...artistSplit,
              percentage: artistSplit.tempSplitPercentage / 100,
            },
          ],
        },
      })
      .then((response) => {
        NotificationManager.success(
          "Artist successfully added",
          "Success",
          2000
        );
        if (isManual) {
          handleShowManualForm();
        } else if (isUpload) {
          handleShowUploadForm();
        }
        getArtists();
        setFilterData({
          ...filterData,
          artist_id: response.data.id,
          artist_name: response.data.name,
        });
        return response.data;
      })
      .catch((error) => {
        setErrorMessage(error.response.data);
      })
      .finally(() => {});
    event.preventDefault();
    setIsFetching(false);
  };

  const handleUpdate = (event) => {
    setIsFetching(true);
    api
      .put("/artists", {
        artist: {
          ...artist,
          artist_splits_attributes: [
            {
              ...artistSplit,
              percentage: artistSplit.tempSplitPercentage / 100,
            },
          ],
        },
      })
      .then((response) => {
        NotificationManager.success(
          "Artist successfully updated",
          "Success",
          2000
        );
        if (isManual) {
          handleShowManualForm();
        } else if (isUpload) {
          handleShowUploadForm();
        }
        getArtists();
        setFilterData({
          ...filterData,
          artist_id: response.data.id,
          artist_name: response.data.name,
        });
        return response.data;
      })
      .catch((error) => {
        setErrorMessage(error.response.data);
      })
      .finally(() => {});
    event.preventDefault();
    setIsFetching(false);
  };

  const afterSubmit = () => {
    getArtists();
  };

  const handleChange = ({ target: { id, value } }) => {
    setArtist({
      ...artist,
      [id]: value,
    });
  };

  const handleSplitChange = ({ target: { id, value } }) => {
    setArtistSplit({
      ...artistSplit,
      [id]: value,
    });
  };

  const handleBooleanChange = ({ target: { name, value } }) => {
    setArtist({
      ...artist,
      [name]: !!value,
    });
  };

  return (
    <div>
      {showManualForm && (
        <AddProduct
          fromArtistPage={fromArtistPage}
          handleShowSelf={handleShowSelf}
          handleShowManualForm={handleShowArtistDrawer}
          handleShowUploadForm={handleShowUploadForm}
          afterSubmit={afterSubmit}
        ></AddProduct>
      )}
      {showUploadForm && (
        <UploadProduct
          fromArtistPage={fromArtistPage}
          handleShowSelf={handleShowSelf}
          handleShowManualForm={handleShowManualForm}
          handleShowUploadForm={handleShowArtistDrawer}
          afterSubmit={afterSubmit}
        ></UploadProduct>
      )}
      {showSelf && (
        <div className="-mt-20 side-modal">
          <div className="flex-col">
            <header className="py-6 px-4 text-lg mb-2 bg-blue-500 text-white">
              <button
                onClick={handleShowArtistDrawer}
                className="float-right -mt-4"
              >
                <FontAwesomeIcon icon={faTimes}></FontAwesomeIcon>
              </button>
              <div>New Artist</div>
              <div className="text-sm">
                You can modify this information later if needed
              </div>
            </header>
            <div className="mt-8 mx-4 tracking-normal	font-medium text-lg text-black">
              Artist Information
            </div>
            <hr className="my-4 mx-4"></hr>
            <form
              className="mx-4 text-black"
              id="submit"
              onSubmit={handleSubmit}
            >
              <div>
                <div className="my-5">
                  <SideLabelInput
                    id="name"
                    type="name"
                    label="Name"
                    value={artist.name}
                    name="name"
                    onChange={handleChange}
                    disabled={isFetching}
                    required
                  />
                  {errorMessage?.errors?.name && (
                    <div className="text-red-500 pt-2">
                      Name {errorMessage.errors.name}
                    </div>
                  )}
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="tempSplitPercentage"
                    type="tempSplitPercentage"
                    label="Artist Split Percentage"
                    value={artistSplit.tempSplitPercentage}
                    name="tempSplitPercentage"
                    onChange={handleSplitChange}
                    disabled={isFetching}
                    required
                  />
                </div>
                <div className="flex items-center text-xs my-5">
                  <label htmlFor="effective_date" className="w-1/3">
                    Effective Date
                  </label>
                  <input
                    value={artistSplit.effective_date}
                    type="date"
                    id="effective_date"
                    name="effective_date"
                    className="h-9 pl-2 ml-5 font-light rounded-md border w-full justify-self-end"
                    onChange={handleSplitChange}
                    disabled={isFetching}
                    required
                  ></input>
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="manager_payment"
                    type="manager_payment"
                    label="Road manager daily rate when artist vends"
                    value={artist.manager_payment}
                    name="manager_payment"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="venue_vended_manager_payment"
                    type="venue_vended_manager_payment"
                    label="Road manager daily rate when artist doesn't vend"
                    value={artist.venue_vended_manager_payment}
                    name="venue_vended_manager_payment"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="tempManagerPercentage"
                    type="tempManagerPercentage"
                    label="Road Manager Commission Percentage"
                    value={artist.tempManagerPercentage}
                    name="tempManagerPercentage"
                    onChange={handleChange}
                    disabled={isFetching}
                    required
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="notes"
                    type="notes"
                    label="Notes"
                    value={artist.notes}
                    name="notes"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="business_name"
                    type="business_name"
                    label="Business Name"
                    value={artist.business_name}
                    name="business_name"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="tax_id"
                    type="tax_id"
                    label="Tax ID"
                    value={artist.tax_id}
                    name="tax_id"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="street_address"
                    type="street_address"
                    label="Street Address"
                    value={artist.street_address}
                    name="street_address"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="city"
                    type="city"
                    label="City"
                    value={artist.city}
                    name="city"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="state"
                    type="state"
                    label="State / Province"
                    value={artist.state}
                    name="state"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
                <div className="my-5">
                  <SideLabelInput
                    id="zip_code"
                    type="zip_code"
                    label="Zip / Postal Code"
                    value={artist.zip_code}
                    name="zip_code"
                    onChange={handleChange}
                    disabled={isFetching}
                  />
                </div>
              </div>
              <fieldset className="flex text-xs">
                <div className="w-1/3">
                  <legend>Active</legend>
                </div>
                <div>
                  <input
                    checked={!artist.active}
                    onChange={handleBooleanChange}
                    type="radio"
                    id="false"
                    name="active"
                    value=""
                  />
                  <label htmlFor="false" className="pl-2 pr-8">
                    No
                  </label>
                </div>
                <div>
                  <input
                    checked={artist.active}
                    onChange={handleBooleanChange}
                    type="radio"
                    id="true"
                    name="active"
                    value={true}
                  />
                  <label htmlFor="true" className="pl-2">
                    Yes
                  </label>
                </div>
              </fieldset>
              <fieldset className="flex text-xs">
                <div className="w-1/3">
                  <legend>TM Tax Responsible</legend>
                </div>
                <div>
                  <input
                    checked={!artist.ctm_tax_responsible}
                    onChange={handleBooleanChange}
                    type="radio"
                    id="false"
                    name="ctm_tax_responsible"
                    value=""
                  />
                  <label htmlFor="false" className="pl-2 pr-8">
                    No
                  </label>
                </div>
                <div>
                  <input
                    checked={artist.ctm_tax_responsible}
                    onChange={handleBooleanChange}
                    type="radio"
                    id="true"
                    name="ctm_tax_responsible"
                    value={true}
                  />
                  <label htmlFor="true" className="pl-2">
                    Yes
                  </label>
                </div>
              </fieldset>
              <div className="mt-8 tracking-normal font-medium text-lg">
                Artist Inventory
              </div>
              <div className="text-xs">
                You can upload inventory for this artist at another time
              </div>
              <hr className="mt-3"></hr>
            </form>
            <div className="grid justify-items-center mt-4">
              <Button
                onClick={handleIsManual}
                id="manual"
                text="Enter manually"
                type="manual"
                form="manual"
                value="Manual"
                disabled={isFetching}
                isChecked={isManual}
                className="button button-white button-3-4"
              ></Button>
              <div className="my-2"></div>
              <Button
                onClick={handleIsUpload}
                id="upload"
                text="Upload"
                type="upload"
                form="upload"
                value="Upload"
                disabled={isFetching}
                isChecked={isUpload}
                className="button button-white button-3-4"
              ></Button>
            </div>
            <div>
              <div className="flex-col">
                <div className="flex justify-center mt-8">
                  {errorMessage?.error && (
                    <div className="text-red-500 pb-4">
                      {errorMessage.error}
                    </div>
                  )}
                </div>
                <div className="flex justify-end mr-4 my-4">
                  {filterData.artist_name !== artist.name ? (
                    <Button
                      text={isFetching ? `Loading ${"\u00A0"}` : "Save"}
                      type="submit"
                      form="submit"
                      value="Submit"
                      disabled={isFetching || !artist.name}
                      inProgress={isFetching}
                      className={artist.name ? "button" : "button-disabled"}
                    ></Button>
                  ) : (
                    <Button
                      text={isFetching ? `Loading ${"\u00A0"}` : "Update"}
                      type="update"
                      value="Update"
                      disabled={isFetching || !artist.name}
                      inProgress={isFetching}
                      onClick={handleUpdate}
                      className={artist.name ? "button" : "button-disabled"}
                    ></Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AddArtist;
